import LogoOpenAI from "../../../../assets/icons/LogoOpenAI";
import LogoClaude from "../../../../assets/icons/LogoClaude";
import MessageTextContainer from "./MessageTextContainer";
import NebiusChatAvatar from "./NebiusChatAvatar";
import modelDescriptors, {
  currentModelDescriptions,
} from "../../../../model/model-providers/modelDescriptors";
import ModelVendors from "../../../../model/model-providers/modelVendors";
import "./AssistantWelcomeMessage.scss";

const AssistantWelcomeMessage = ({ assistant, chat }) => {
  if (!assistant || !assistant.welcomeMessage || assistant.welcomeMessage.trim() === "") {
    return null;
  }

  // Determine the model vendor (same logic as ChatMessage)
  const model = currentModelDescriptions.find(
    (item) => item.id === chat?.modelId
  );
  const oldModel = modelDescriptors.find((item) => item.id === chat?.modelId);
  const vendor = model?.vendor || oldModel?.vendor;

  return (
    <div className="assistant_welcome_message chat_message assistant">
      <div className="avatar">
        {vendor === ModelVendors.OPENAI && (
          <div className="openai_avatar">
            <LogoOpenAI color="#fff" />
          </div>
        )}
        {vendor === ModelVendors.ANTHROPIC && (
          <div className="claude_avatar">
            <LogoClaude color="#fff" size={24} />
          </div>
        )}
        {vendor === ModelVendors.NEBIUS && (
          <NebiusChatAvatar modelId={chat?.modelId} />
        )}
      </div>
      <div className="message_item">
        <MessageTextContainer>{assistant.welcomeMessage}</MessageTextContainer>
      </div>
    </div>
  );
};

export default AssistantWelcomeMessage;
